"use client";

import React from "react";
import { Loader as Loader2, CircleCheck as CheckCircle2 } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
function DemoFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center animate-in fade-in duration-500">
        <div className="size-16 bg-[#078855]/20 rounded-lg flex items-center justify-center mb-6">
          <CheckCircle2 className="size-8 text-[#078855]" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-white mb-2">
          ¡Solicitud Enviada!
        </h3>
        <p className="text-slate-300 mb-8 max-w-sm">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="border-white/20 text-white hover:bg-white/10 hover:text-white">
          Enviar otra solicitud
        </Button>
      </div>;
  }
  const inputClasses = "bg-transparent border-white/20 text-white placeholder:text-white/40 focus-visible:ring-[#078855] focus-visible:border-transparent transition-colors";
  const labelClasses = "text-slate-200 font-medium";
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField control={control} name="nombre" rules={{
        required: "El nombre es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClasses}>Nombre *</FormLabel>
              <FormControl>
                <Input placeholder="Tu nombre completo" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "El email es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClasses}>Email *</FormLabel>
              <FormControl>
                <Input type="email" placeholder="correo@empresa.com" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField control={control} name="telefono" rules={{
        required: "El teléfono es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClasses}>Teléfono *</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+34 600 000 000" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="empresa" render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClasses}>Empresa</FormLabel>
              <FormControl>
                <Input placeholder="Nombre de tu empresa" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />
      </div>

      <FormField control={control} name="tipoSolucion" render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>Tipo de Solución</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className={inputClasses}>
                  <SelectValue placeholder="Selecciona una opción" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="bg-slate-800 border-slate-700 text-white">
                <SelectItem value="teams-room" className="focus:bg-slate-700 focus:text-white">Teams Room</SelectItem>
                <SelectItem value="ip-phones" className="focus:bg-slate-700 focus:text-white">IP Phones</SelectItem>
                <SelectItem value="hibrida" className="focus:bg-slate-700 focus:text-white">Solución Híbrida</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      <FormField control={control} name="mensaje" render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>Mensaje</FormLabel>
            <FormControl>
              <Textarea placeholder="¿En qué podemos ayudarte?" className={`resize-none min-h-[100px] ${inputClasses}`} {...field} />
            </FormControl>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-md">
          <p className="text-red-400 text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-[#078855] hover:bg-[#067046] text-white h-12 text-base font-medium rounded-md transition-colors">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 size-5" />
            Enviando...
          </> : "Enviar Solicitud"}
      </Button>
    </Form>;
}
export default function FormularioDeContactoSolicitarDemo() {
  return <section id="formulario-de-contacto-solicitar-demo" className="relative bg-slate-950 py-20 lg:py-32 overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#078855]/15 rounded-lg blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-500/10 rounded-lg blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="lg:col-span-7 text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-white/5 border border-white/10 text-sm font-medium text-slate-300 mb-6">
              <span className="size-2 rounded-lg bg-[#078855] animate-pulse" />
              Atención Personalizada
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold leading-tight mb-6">
              Solicita una Demo <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#078855] to-emerald-400">
                Personalizada
              </span>
            </h2>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl leading-relaxed">
              Nuestro equipo de expertos te guiará a través de soluciones Yealink adaptadas a tu espacio de reuniones. Descubre cómo podemos transformar la colaboración en tu empresa con tecnología de vanguardia.
            </p>
            
            <div className="mt-10 grid grid-cols-2 gap-6 max-w-lg">
              <div className="flex flex-col gap-2">
                <div className="text-3xl font-bold text-white">100%</div>
                <div className="text-sm text-slate-400">Adaptado a tus necesidades</div>
              </div>
              <div className="flex flex-col gap-2">
                <div className="text-3xl font-bold text-white">24/48h</div>
                <div className="text-sm text-slate-400">Tiempo de respuesta</div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5">
            <div className="bg-slate-900/60 backdrop-blur-md border border-white/10 p-6 sm:p-8 rounded-2xl shadow-2xl">
              <div className="mb-8">
                <h3 className="text-2xl font-default font-semibold text-white mb-2">
                  Comencemos
                </h3>
                <p className="text-slate-400 text-sm">
                  Completa el formulario y nos pondremos en contacto contigo a la brevedad.
                </p>
              </div>

              <FormProvider formId="demo-request-form" sectionName="Contact Conversion Demo" defaultValues={{
              nombre: "",
              email: "",
              telefono: "",
              empresa: "",
              tipoSolucion: "",
              mensaje: ""
            }} submitText="Enviar Solicitud" successMessage="Gracias por tu interés. Nuestro equipo se pondrá en contacto contigo muy pronto para coordinar la demo.">
                <DemoFormContent />
              </FormProvider>
            </div>
          </div>

        </div>
      </div>
    </section>;
}